import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
  FaFilePdf,
  FaInstagram,
} from "react-icons/fa";

export const links = [
  {
    index: 0,
    title: "Github",
    href: "https://github.com/mint13",
    icon: <FaGithub />,
  },
  {
    index: 1,
    title: "LinkedIn",
    href: "https://www.linkedin.com/in/mint-medillo/",
    icon: <FaLinkedin />,
  },
  {
    index: 2,
    title: "Instagram",
    href: "https://www.instagram.com/_mintm13/",
    icon: <FaInstagram  />,
  },
  {
    index: 3,
    title: "Get in Touch",
    href: "mailto:mintmedillo13@gmail.com",
    icon: <FaEnvelope />,
  },
  {
    index: 4,
    title: "Curriculum Vitae",
    href: "https://drive.google.com/file/d/1n0TU8AMwrNC_y3imlf5vvq7EzwnVqSoR/view",
    icon: <FaFilePdf />,
  },
];
